const { DataServiceEndPoint } = require("@cloudbreakus/network-utilities")

class Anymeeting extends DataServiceEndPoint {
  static key = "Anymeeting"

  static EPIC_EVENTS = [
    "Epic.Video.AuthSuccess",
    "Epic.Video.AuthFailure",
    "Epic.Video.Connected",
    "Epic.Video.ParticipantUpdate",
    "Epic.Video.Disconnected",
    "Epic.Video.WaitingForAdmission",
  ]
  // epic events will be removed in the next iteration, temporary keep them to ensure backward compatibility

  static ANYMEETING_EVENTS = [
    "AuthSuccess",
    "AuthFailure",
    "Connected",
    "ParticipantUpdate",
    "Disconnected",
    "WaitingForAdmission",
  ]

  static GENERAL_EVENTS = ["KeepAlive", "Opened", "Closed", "Completed"]

  async handleEvent({ event, payload, interactionId, taskId, agentId }) {
    if (![...Anymeeting.EPIC_EVENTS, ...Anymeeting.ANYMEETING_EVENTS, ...Anymeeting.GENERAL_EVENTS].includes(event)) {
      throw new Error(`unsupported Anymeeting event: ${event}`, event)
    }
    const reqBody = {
      event,
      payload: this.maybeStringifyPayload(payload),
      interactionId,
      taskId,
    }

    const reqConfig = {
      headers: { Authorization: `bearer ${this.token}` },
      throttle: {
        maxCalls: 10,
      },
    }

    if (Anymeeting.GENERAL_EVENTS.includes(event)) {
      await Promise.all([
        this._httpService.post(`${this.url}/v1/anymeeting-events`, reqBody, reqConfig),
        this._httpService.post(`${this.url}/v1/emr-events`, { ...reqBody, agentId }, reqConfig),
      ])
    }

    if (Anymeeting.EPIC_EVENTS.includes(event)) {
      await this._httpService.post(`${this.url}/v1/emr-events`, { ...reqBody, agentId }, reqConfig)
    }

    if (Anymeeting.ANYMEETING_EVENTS.includes(event)) {
      await this._httpService.post(`${this.url}/v1/anymeeting-events`, reqBody, reqConfig)
    }
  }

  maybeStringifyPayload(payload) {
    if (!payload || typeof payload === "string") {
      return payload
    }

    return JSON.stringify(payload)
  }
}

module.exports = Anymeeting
